import React from "react";
import styled from "styled-components";
var ButtonWrapper = styled.div.withConfig({
  componentId: "sc-13ocvss-0"
})(["opacity:0.8;&:hover{opacity:1;}"]);
var ModalButtonWrapper = function ModalButtonWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ButtonWrapper, null, children);
};
export default ModalButtonWrapper;